import { HStack } from '@pets-ui/HStack/HStack'
import { Fragment, type ReactNode } from 'react'

export interface CouponConditionWrapperProps {
  children: ReactNode
  useCssGrid?: boolean
}

export const CouponConditionWrapper = (props: CouponConditionWrapperProps) => {
  const { children, useCssGrid } = props
  const Wrapper = useCssGrid ? Fragment : HStack
  const wrapperProps = useCssGrid ? {} : { gap: 2, alignItems: 'center' as const }

  return (
    <Wrapper {...wrapperProps}>{children}</Wrapper>
  )
}
